import React, { useState, useEffect } from "react";
import { api } from "@/lib/api";

export function VerifyEmailPage() {
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link");
      return;
    }

    api.post("/v1/auth/verify-email", { token })
      .then(async (res) => {
        const data = await res.json();
        if (res.ok) {
          setStatus("success");
          setMessage(data.message || "Email verified successfully");
        } else {
          setStatus("error");
          setMessage(data.error || data.message || "Verification failed");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("Network error. Please try again.");
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">ClickDash</h1>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center space-y-3">
          {status === "loading" && (
            <>
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900 mx-auto" />
              <p className="text-sm text-gray-500">Verifying your email...</p>
            </>
          )}

          {status === "success" && (
            <>
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
              </div>
              <h2 className="text-lg font-semibold text-gray-900">Email Verified</h2>
              <p className="text-sm text-gray-500">{message}</p>
              <a href="/login" className="inline-block bg-gray-900 text-white rounded-lg px-6 py-2 text-sm font-medium hover:bg-gray-800 transition-colors mt-2">
                Go to Dashboard
              </a>
            </>
          )}

          {status === "error" && (
            <>
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto">
                <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-lg font-semibold text-red-600">Verification Failed</h2>
              <p className="text-sm text-gray-500">{message}</p>
              <a href="/login" className="inline-block text-sm text-gray-900 font-medium hover:underline mt-2">
                Back to login
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
